export default __webpack_public_path__ + "static/media/oasis-family-2.f81a2766.png";